export const storage = localStorage

export const getItemFromStorage = ({name}) => JSON.parse(storage.getItem(name))

export const setDataInStorage = ({name, data}) =>
  storage.setItem(name, JSON.stringify(data))

export const removeItemFromStorage = ({name}) => storage.removeItem(name)

// Business storage functions
export const getSelectedBusinessId = () => {
  try {
    const businessId = localStorage.getItem('selectedBusinessId')
    return businessId
  } catch (error) {
    console.error('Error getting selected business:', error)
    return null
  }
}

export const setSelectedBusinessId = (businessId) => {
  try {
    if (businessId) {
      localStorage.setItem('selectedBusinessId', businessId)
    } else {
      localStorage.removeItem('selectedBusinessId')
    }
  } catch (error) {
    console.error('Error setting selected business:', error)
  }
}

export const getActingAsPersonal = () => {
  try {
    const actingAsPersonal = localStorage.getItem('actingAsPersonal')
    return actingAsPersonal === 'true'
  } catch (error) {
    console.error('Error getting acting as personal:', error)
    return false
  }
}

export const setActingAsPersonal = (isPersonal) => {
  try {
    localStorage.setItem('actingAsPersonal', isPersonal.toString())
  } catch (error) {
    console.error('Error setting acting as personal:', error)
  }
}

// What the signup CTA was for ('add-business'), carried through email
// verification so onboarding can open on the business branch. Cleared
// when onboarding finishes.
export const setSignupIntent = (intent) => {
  try {
    localStorage.setItem('signupIntent', intent)
  } catch (error) {
    // non-critical
  }
}

export const getSignupIntent = () => {
  try {
    return localStorage.getItem('signupIntent')
  } catch (error) {
    return null
  }
}

export const clearSignupIntent = () => {
  try {
    localStorage.removeItem('signupIntent')
  } catch (error) {
    // non-critical
  }
}

// Anonymous visitor id for touchpoint analytics — a random UUID persisted in
// localStorage so logged-out views can be counted (and stitched to the same
// visitor across pages). Never contains PII.
export const getAnonymousId = () => {
  try {
    let anonymousId = localStorage.getItem('anonymousId')
    if (!anonymousId) {
      anonymousId = crypto.randomUUID
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
          })
      localStorage.setItem('anonymousId', anonymousId)
    }
    return anonymousId
  } catch (error) {
    return null
  }
}

export const clearBusinessContext = () => {
  try {
    localStorage.removeItem('selectedBusinessId')
    localStorage.removeItem('actingAsPersonal')
  } catch (error) {
    console.error('Error clearing business context:', error)
  }
}
